import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Returns scan to pay feature flag value to enable/disable certain features.
 */
export const useScanToPayFeatureFlag = () => {
  return useFeatureFlag('permanent-scan-to-pay-enabled', {
    listenForChanges: true,
  });
};
